import { useSyncExternalStore } from 'react';
import SkeletonPulse from '@/context/ClipsContext/ClipSkeletonLoader/components/SkeletonPulse';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

export default function RecentEventsSkeleton() {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isCLHomePageEnabled = featureFlags[FeatureFlagKeys.Use_CL_New_HomePage];

  if (isCLHomePageEnabled) {
    return (
      <div className="flex items-center gap-6">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="w-72 shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-white"
            style={{ maxWidth: '298px' }}
          >
            <div className="relative">
              <SkeletonPulse classname="aspect-video w-full" />
              <SkeletonPulse classname="absolute bottom-2 right-2 size-6 rounded-full" />
            </div>

            <div className="p-4">
              <SkeletonPulse classname="mb-2 h-4 w-3/4 rounded" />
              <SkeletonPulse classname="h-4 w-full rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return Array.from({ length: 5 }).map((_, i) => (
    <div
      className="h-[17.25rem] w-[23rem] shrink-0 animate-pulse !rounded-xl bg-slate-200/50 pb-1"
      key={'recent-events-skeleton' + i}
    ></div>
  ));
}
